<div
  class="container"
  cdkDrag
  cdkDragBoundary=".cdk-overlay-pane"
  cdkDragRootElement=".mat-bottom-sheet-container"
  cdkDragLockAxis="y"
  (cdkDragEnded)="closeBottomSheet($event)"
  >
  @if (!(popUpData.data?.hideDivider ?? false)) {
    <mat-divider
      class="!mx-auto w-3/12 h-1 !border-none bg-gray rounded-lg"
      cdkDragHandle
      />
  }

  <div #trapContainer class="p-2" role="presentation">
    <ng-template #dynamicComponentContainer></ng-template>
  </div>
</div>
